<template>
	<div>
		<div class="cl-theme ftr-1-25 ftw600">
			{{$t('common.memberClassReport',{name:classItem.user_info.nickname})}}
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.classroomReport1')}}
		</div>
		<div class="mt-1 flex alcenter ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.classroomReport2')}}:</div>
			<a-input :placeholder="$t('common.enter')" style="width: 220px;" v-model="info.name" ></a-input>
		</div>
		<div class="mt-1 flex alcenter ftw600">
			<div style="width: 80px;">{{$t('teacherIndex.classroomReport3')}}:</div>
			<a-input :placeholder="$t('common.enter')" style="width: 220px;" v-model="info.learning_focus" ></a-input>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.classroomReport4')}}
		</div>
		<div class="flex alcenter">
			<div>
				<div class="mt-1 flex alcenter ftw600">
					<div style="width: 80px;">{{$t('teacherIndex.classroomReport5')}}:</div>
					<a-input :placeholder="$t('common.enter')" style="width: 150px;" v-model="info.score_concentration"></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_concentration))">
						{{getScore(info.score_concentration)}}
					</div>
				</div>
				<div class="mt-1 flex alcenter ftw600">
					<div style="width: 80px;">{{$t('teacherIndex.classroomReport8')}}:</div>
					<a-input :placeholder="$t('common.enter')" style="width: 150px;" v-model="info.score_range_advancement"></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_range_advancement))">
						{{getScore(info.score_range_advancement)}}
					</div>
				</div>
			</div>
			
			<div class="ms-5">
				<div class="mt-1 flex alcenter ftw600">
					<div style="width: 80px;">{{$t('teacherIndex.classroomReport6')}}:</div>
					<a-input :placeholder="$t('common.enter')" style="width: 150px;" v-model="info.score_degree_mastery"></a-input>
					<div class=" ml16" :class="getColor(getScore(info.score_degree_mastery))">
						{{getScore(info.score_degree_mastery)}}
					</div>
				</div>
				<div class="mt-1 flex alcenter ftw600">
					<div style="width: 80px;">{{$t('teacherIndex.classroomReport9')}}:</div>
					<a-input :placeholder="$t('common.enter')" style="width: 150px;" v-model="info.score_assignment"></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_assignment))">
						{{getScore(info.score_assignment)}}
					</div>
				</div>
			</div>
			<div class="ms-5">
				<div class="mt-1 flex alcenter ftw600">
					<div style="width: 80px;">{{$t('teacherIndex.classroomReport7')}}:</div>
					<a-input :placeholder="$t('common.enter')" style="width: 150px;" v-model="info.score_degree_participation"></a-input>
					<div class="ml16" :class="getColor(getScore(info.score_degree_participation))">
						{{getScore(info.score_degree_participation)}}
					</div>
				</div>
				<div class="mt-1 flex alcenter ftw600">
					<div style="width: 80px;">{{$t('teacherIndex.classroomReport10')}}:</div>
					<div class="ml16" :class="getColor(getScoreTotal())">
						{{getScoreTotal()}}
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('teacherIndex.classroomReport11')}}
		</div>
		<div class="flex alcenter">
			<div style="width: 80px;" class="ftw600" >{{$t('teacherIndex.classroomReport12')}}:</div>
			<a-select style="width: 220px;" size="large" v-model="info.class_highlights">
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in class_highlights_list">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.class_highlights" ></a-input>
		</div>
		<div class="flex alcenter mt-2">
			<div style="width: 80px;" class="ftw600" >{{$t('teacherIndex.classroomReport13')}}:</div>
			<a-select style="width: 220px;" size="large" v-model="info.learning_advice">
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in learning_advice_list">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.learning_advice"></a-input>
		</div>
		<div class="flex alcenter mt-2">
			<div style="width: 80px;" class="ftw600" >{{$t('teacherIndex.classroomReport14')}}:</div>
			<a-select style="width: 220px;" size="large" v-model="info.next_lesson_preview">
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in next_lesson_preview_list">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.next_lesson_preview"></a-input>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('studentsCom.workOrTest')}}
		</div>
		<div class="mt-2">
			<a-checkbox-group @change="changeWorkTest" v-model="work_testing">
				<a-checkbox :value="1">{{$t('teacherConfirms.homework')}}</a-checkbox>
				<br />
				<a-checkbox :value="2">{{$t('teacherConfirms.test')}}</a-checkbox>
			</a-checkbox-group>
		</div>
		<div class="mt-3 cl-theme ftw600">
			{{$t('studentsCom.supportYou')}}
		</div>
		<div class="flex alcenter mt-2">
			<a-select style="width: 220px;" size="large" v-model="info.support">
				<a-select-option :value="''" >
					{{$t('common.select')}}
				</a-select-option>
				<a-select-option :value="item.copywrite" v-for="(item,index) in support_list">
					{{item.copywrite}}
				</a-select-option>
			</a-select>
			<a-input :placeholder="$t('common.enter')" class="ml10" style="width: 450px;" v-model="info.support"></a-input>
		</div>
		
		<div class="mt-4 flex alcenter">
			<div class="btn btn-theme" @click="submit()" v-if="isAdd">
				{{$t('teacherIndex.classroomReport15')}}
			</div>
			<div class="btn btn-outline-gray ml15" @click="navBack()">
				{{$t('common.back')}}
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				classItem:{},//选中的课堂详情
				info:{
					order_id:0,
					name:'',//课题
					learning_focus:'',//学习重点
					score_concentration:'',//专注力评分
					score_degree_mastery:'',//掌握度评分
					score_degree_participation:'',//参与度评分
					score_range_advancement:'',//进步幅度评分
					score_assignment:'',//作业/测验评分
					score_average:'',//综合评分（自动计算）
					class_highlights:'',//课堂亮点
					learning_advice:'',//学习建议
					next_lesson_preview:'',//下堂预告
					support:'',//鼓励
					assignment_switch:0,//作业 1=是 0=否
					testing_switch:0,//测验 1=是 0=否
				},
				selectList:[],
				class_highlights_list:[],//课堂亮点 预设字段
				learning_advice_list:[],//学习建议 预设字段
				next_lesson_preview_list:[] ,//下堂预告 预设字段
				support_list:[],//鼓励 预设字段
				work_testing:[],
				isAdd:true
			}
		},
		async created() {
			this.classItem = JSON.parse(this.$route.query.classItem) 
			console.log("____",this.classItem);
			this.info.order_id = this.classItem.id
			let arr = await this.informationIntegration(['presetCopywrit'])
			this.selectList = arr.list.presetCopywrit.list
			this.handleSelect()
			this.getDetails()
			
		},
		methods:{
			changeWorkTest(){
				console.log("------this.work_testing",this.work_testing);
				this.info.assignment_switch =  this.work_testing.includes(1)?1:0
				this.info.testing_switch =  this.work_testing.includes(2)?1:0
			},
			handleSelect(){
				this.class_highlights_list = []
				this.learning_advice_list = []
				this.next_lesson_preview_list = []
				this.support_list = []
				this.selectList.forEach((item,index)=>{
					if(item.type=='1'){
						this.class_highlights_list.push(item)
					}
					if(item.type=='2'){
						this.learning_advice_list.push(item)
					}
					if(item.type=='3'){
						this.next_lesson_preview_list.push(item)
					}
					if(item.type=='4'){
						this.support_list.push(item)
					}
				})
			},
			getScore(score){
				if(score==''){
					return ' '
				}
				let num = Number(score)
				if(num<=50){
					return 'C-'
				}else if(num>50&&num<=55){
					return 'C'
				}else if(num>55&&num<=60){
					return 'C+'
				}else if(num>60&&num<=65){
					return 'B-'
				}else if(num>65&&num<=70){
					return 'B'
				}else if(num>70&&num<=75){
					return 'B+'
				}else if(num>75&&num<=80){
					return 'A-'
				}else if(num>80&&num<=90){
					return 'A'
				}else if(num>90){
					return 'A+'
				}
			},
			getScoreTotal(){
				let num
				num = Number(this.info.score_concentration)+Number(this.info.score_degree_mastery)+Number(this.info.score_degree_participation)
				+Number(this.info.score_range_advancement)+Number(this.info.score_assignment)
				this.info.score_average = num/5
				return this.info.score_average ? this.getScore(this.info.score_average):''
			},
			getColor(str){
				if(str.includes('A')){
					return 'cl-theme'
				}else if(str.includes('B')){
					return 'cl-b'
				}else{
					return 'cl-c'
				}
			},
			getDetails(){
				this.$http.api('teacher/reservation/reportDetail',{order_id:this.info.order_id}).then(res=>{
					if(res.info){
						this.isAdd = false
						this.info.name = res.info.name
						this.info.learning_focus = res.info.learning_focus
						this.info.score_concentration = res.info.score_concentration
						this.info.score_degree_mastery = res.info.score_degree_mastery
						this.info.score_degree_participation = res.info.score_degree_participation
						this.info.score_range_advancement = res.info.score_range_advancement
						this.info.score_assignment = res.info.score_assignment
						this.info.score_average = res.info.score_average
						this.info.class_highlights = res.info.class_highlights
						this.info.learning_advice = res.info.learning_advice
						this.info.next_lesson_preview = res.info.next_lesson_preview
						this.info.support = res.info.support
						this.info.assignment_switch = res.info.assignment_switch
						this.info.testing_switch = res.info.testing_switch
						if(this.info.assignment_switch==1){
							this.work_testing.push(1)
						}
						if(this.info.testing_switch==1){
							this.work_testing.push(2)
						}
					}else{
						this.isAdd = true
					}
				})
			},
			submit(){
				this.$confirm({
					title: this.$t('common.confirmSubmit'),
					content: this.$t('common.cancelSubmitText'),
					okText: this.$t('teacherConfirms.confirmAction'),
					okType: "danger",
					cancelText: this.$t('teacherConfirms.cancelAction'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/reservation/createReport',this.info).then(res=>{
							
							// this.$http.api('teacher/reservation/accomplishOrder',{
							// 	order_id:this.info.order_id
							// }).then(res=>{
							// 	this.$message.success(this.$t('common.operationSuccessful'),2,()=>{
							// 		this.$router.back()
							// 	})
							// })
							
							this.$message.success(this.$t('common.operationSuccessful'),2,()=>{
								this.$router.back()
							})
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				})
				
				
			},
			navBack(){
				this.$router.back()
			}
		}
	}
</script>

<style>
	.cl-b{
		color: #92D050;
	}
	.cl-c{
		color: #FFC000;
	}
</style>